import * as React from 'react'

export const SvgFilter: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      {...{ className }}
      width='10'
      height='11'
      viewBox='0 0 10 11'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.242 4.70616e-06H0.76039C0.343262 -0.00146282 0.00144836 0.340471 0 0.764587C0 0.908404 0.0391058 1.05075 0.114421 1.17403L3.16902 6.24874V9.1427C3.16757 9.89994 3.62091 10.5823 4.31467 10.8641C5.25321 11.2486 6.32065 10.7893 6.70013 9.83831C6.78848 9.61671 6.83337 9.38044 6.83337 9.1427V6.24874L9.88507 1.17403C10.1067 0.814483 9.99805 0.340471 9.6432 0.115939C9.52443 0.039628 9.38394 4.70616e-06 9.242 4.70616e-06ZM5.76593 5.77913C5.708 5.87158 5.67613 5.97724 5.67469 6.08731V9.1427C5.67469 9.51985 5.37343 9.8251 5.0012 9.8251C4.91429 9.8251 4.82884 9.80896 4.74918 9.7752C4.49572 9.67101 4.3306 9.42153 4.33205 9.14417V6.08731C4.33205 5.98018 4.30309 5.87452 4.24805 5.78206L1.47443 1.17403H8.52796L5.76593 5.77913Z'
        fill='white'
      />
    </svg>
  )
}
